import "../../../assets/presentation/components/modal-views/dialog-9z5NnVyv.css";
import { ModalView, ModalViewAnchor, ModalViewContainer, ModalViewLayout, ModalViewScrim } from "./modal-view2.js";
/* empty css       */
import classNames from "classnames";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/presentation/components/modal-views/dialog.tsx
var Dialog = ({ children, className, isPending, loadingText, hide, showBottomSheetVersionInSmallDevices = false }) => {
	return /* @__PURE__ */ jsxs(ModalView, {
		className: classNames(className, "dialog", { "bottom-sheet-in-small-devices": showBottomSheetVersionInSmallDevices }),
		children: [/* @__PURE__ */ jsx(ModalViewScrim, {}), /* @__PURE__ */ jsx(ModalViewLayout, { children: /* @__PURE__ */ jsx(ModalViewAnchor, { children: /* @__PURE__ */ jsx(ModalViewContainer, {
			isPending,
			loadingText,
			onClickOutside: () => {
				hide?.();
			},
			children
		}) }) })]
	});
};
var DialogButtons = ({ children, className }) => /* @__PURE__ */ jsx("div", {
	className: classNames(className, "buttons"),
	children
});
var DialogContent = ({ children, className }) => /* @__PURE__ */ jsx("div", {
	className: classNames(className, "content"),
	children
});
var DialogHeader = ({ children, className }) => /* @__PURE__ */ jsx("div", {
	className: classNames(className, "header"),
	children
});
//#endregion
export { Dialog, DialogButtons, DialogContent, DialogHeader };

//# sourceMappingURL=dialog2.js.map